import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { Job } from '../modules/careers/job.interface';

@Injectable({
  providedIn: 'root',
})
export class CareerService {
  constructor(private http: HttpClient) { }

  // applyJob(data: any) {
  //   return this.http.post(environment.apiUrl + 'Email/SendEmailForJob', data);
  // }
  private handleError(error: HttpErrorResponse) {
    console.error('API Error:', error);
    return throwError(() => new Error('Something went wrong; please try again later.'));
  }

  applyIndiaJob(data: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'Email/SendEmailForIndiaJob', data);
  }

  applyUSAJob(data: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'Email/SendEmailForUSAJob', data);
  }

  getJob(): Observable<Job[]> {
    return this.http.get<Job[]>(environment.apiUrl + 'JobListing/GetJobList');
  }

  sendContactData(data: any) {
    return this.http.post(environment.apiUrl + 'Email/SendEmailForContactUS', data);
  }

  sendtoMail(data: any) {
    return this.http.post(environment.apiUrl + 'Email/SendEmailForSubscribe', data);
  }

  sendToFresherJob(data: any) {
    return this.http.post(environment.apiUrl + 'Email/FresherJobOpening', data);
  }

  sendEmailForRegisterWebinar(data: any) {
    return this.http.post(environment.apiUrl + 'Email/SendEmailForRegisterWebinar', data);
  }
}